import React, { createContext, useContext } from 'react';
import { useNode } from '@craftjs/core';
import { ContainerSettings } from './ContainerSettings';
import { Resizer } from '../Resizer';

const InheritedTextColorContext = createContext(null);
export const useInheritedTextColor = () => useContext(InheritedTextColorContext);

const defaultProps = {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    fillSpace: 'no',
    padding: ['0', '0', '0', '0'],
    margin: ['0', '0', '0', '0'],
    background: { r: 255, g: 255, b: 255, a: 0 }, 
    color: null, 
    shadow: 0,
    radius: 0,
    width: '100%',
    height: 'auto',
};

export const Container = (props) => {
    const finalProps = {
        ...defaultProps,
        ...props,
    };
    const { flexDirection, alignItems, justifyContent, fillSpace, background, color, padding, margin, shadow, radius, children, width, height } = finalProps;    
    
    const { connectors: { connect }, inNodeContext } = useNode((node) => ({
        inNodeContext: node.inNodeContext
    }));
    
    const inheritedColor = useInheritedTextColor();

    const textColor = color || inheritedColor || { r: 0, g: 0, b: 0, a: 1 };
  
    const finalHeight = inNodeContext ? height : 'auto'; 
    const finalWidth = inNodeContext ? width : '100%';
  
    return (
      <Resizer
        key={React.Children.count(children)}
        ref={connect}
        propKey={inNodeContext ? { width: 'width', height: 'height' } : undefined}
        style={{
            justifyContent,
            flexDirection,
            alignItems,
            background: `rgba(${Object.values(background)})`,
            color: `rgba(${Object.values(textColor)})`,
            padding: `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`,
            margin: `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`,
            boxShadow: shadow === 0
                ? 'none'
                : `0px 3px 100px ${shadow}px rgba(0, 0, 0, 0.13)`,
            borderRadius: `${radius}px`,
            flex: fillSpace === 'yes' ? 1 : 'unset',
            height: finalHeight, 
            width: finalWidth,
        }}
    >
      <InheritedTextColorContext.Provider value={textColor}>
        {children}
      </InheritedTextColorContext.Provider>
    </Resizer>
    );
};

Container.craft = {
    displayName: 'Contenedor',
    props: defaultProps,
    rules: {
        canDrag: () => true,
    },
    related: {
        toolbar: ContainerSettings,
    },
};